// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import * as util from 'biojs/Util';
import {CRISPRAnalysis} from 'constants/CRISPRConstants';
import HelpTooltip from 'help/HelpTooltip';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import CRISPRAssemblyActions from './CRISPRAssemblyActions';
import CRISPRAssemblyStore from './CRISPRAssemblyStore';

interface Props {
  analysis: CRISPRAnalysis;
  assemblyCid: string;
  assemblies: Array<{
    name?: string;
    bases?: string;
  }>;
}

class AssemblyList extends React.Component<Props> {
  addAssembly = (): void => {
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      assemblies: reactUpdate(this.props.assemblies, {$push: [{name: '', bases: ''}]}),
    });
  };

  removeAssembly = (rowIndex: number): void => {
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      assemblies: reactUpdate(this.props.assemblies, {$splice: [[rowIndex, 1]]}),
    });
  };

  _handleChangeAssemblyName = (rowIndex: number, newValue: string): void => {
    const op = _.object([[rowIndex, {$merge: {name: newValue}}]]);
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      assemblies: reactUpdate(this.props.assemblies, op),
    });
  };

  _handleChangeAssemblyBases = (rowIndex: number, newValue: string): void => {
    const sanitizedValue = util.sanitize(newValue, util.NucleotideType.DNA);
    const op = _.object([[rowIndex, {$merge: {bases: sanitizedValue}}]]);
    CRISPRAssemblyActions.updateAssembly(this.props.assemblyCid, {
      assemblies: reactUpdate(this.props.assemblies, op),
    });
  };

  render(): JSX.Element {
    return (
      <FormGroup>
        <Row>
          <Col sm={5}>
            <Label>Assembly Name</Label>
          </Col>
          <Col sm={5}>
            <Label>
              {'Guide Sequence '}
              {CRISPRAssemblyStore.shouldPrependG(this.props.analysis) ? (
                <HelpTooltip text="Assembly will prepend G to guides that do not start with G." />
              ) : undefined}
            </Label>
          </Col>
        </Row>
        {this.props.assemblies.length === 0 ? (
          <Row>
            <Col sm={12}>
              <p>No assemblies to make. Click the "Add" button below.</p>
            </Col>
          </Row>
        ) : (
          Array.from(this.props.assemblies).map((assembly, rowIndex) => (
            <Row key={rowIndex}>
              <Col sm={5}>
                <input
                  type="text"
                  value={this.props.assemblies[rowIndex].name}
                  onChange={(e) => {
                    this._handleChangeAssemblyName(rowIndex, e.target.value);
                  }}
                />
              </Col>
              <Col sm={5}>
                <input
                  type="text"
                  value={this.props.assemblies[rowIndex].bases}
                  onChange={(e) => {
                    this._handleChangeAssemblyBases(rowIndex, e.target.value);
                  }}
                />
              </Col>
              <Col sm={1}>
                <a
                  className="faded u-danger-pointer u-input-line-height"
                  onClick={this.removeAssembly.bind(this, rowIndex)}
                >
                  <BenchlingIcon icon="xmark-large" />
                </a>
              </Col>
            </Row>
          ))
        )}
        <Row>
          <Col sm={12}>
            <Button
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
              size={ButtonSize.SMALL}
              onClick={this.addAssembly}
              text={
                <span>
                  <BenchlingIcon icon="search-filter-add" className="u-mini-spacing-right" />
                  Add
                </span>
              }
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default AssemblyList;
